/** ローディング中のコンポーネント */
export const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 z-50">
      <div className="loader border-t-transparent border-4 border-blue-500 rounded-full w-16 h-16 animate-spin" />
    </div>
  );
};
